module.exports = __webpack_public_path__ + "img/jumbopack-inactive.c783a48a.svg";